/** A neutral message above the current step. Never an error state. */

interface NoticeProps {
  message: string | null;
}

export function Notice({ message }: NoticeProps) {
  if (message === null) return null;
  return (
    <p className="notice" role="status">
      {message}
    </p>
  );
}
